import { PRODUCT_FIELD_RULES as sharedRules } from 'generated/productRequirements/rules';
import { ProductFieldRuleType } from './type';

// Keep native form field types at the UI boundary; the generated registry is shared with the backend.
export const PRODUCT_FIELD_RULES = sharedRules as ProductFieldRuleType[];
